module.exports = __webpack_public_path__ + "hockey_round-f8ccb91013f8011c226c72f5b1329fd6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/se/hockey_round.png
// module id = 1193
// module chunks = 1 2